import React from 'react';
import { useNavigate } from 'react-router-dom';
import './GameModeDisabled.css';

interface GameModeDisabledProps {
  gameMode: string;
}

const GameModeDisabled: React.FC<GameModeDisabledProps> = ({ gameMode }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Navigate to coinflip (default page) when going back
    navigate('/');
  };

  return (
    <div className="gamemode-disabled-overlay">
      <div className="gamemode-disabled-modal">
        <div className="gamemode-disabled-content">
          <h3>This gamemode isn't finished</h3>
          <p>{gameMode} is currently under development</p>
          <button 
            className="go-back-btn"
            onClick={handleGoBack}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameModeDisabled;